module.exports = __webpack_public_path__ + "img/wingDRiderLogo@2x.8221f85c.webp";